import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { FinancialDocumentEventFragment } from 'generated/resources/graphql'

import { dateBackendDateTimeToUI, dateBackendDateTimeToUITime } from 'modules/core/lib/dates'

import { getEventErrorMessage, mapEventText, mapEventTypeIcon } from './utils'

interface SaleInvoiceActivityRowProps {
  event: FinancialDocumentEventFragment
  showLine?: boolean
}

export const SaleInvoiceActivityRow: React.FC<SaleInvoiceActivityRowProps> = ({
  event,
  showLine = false,
}) => {
  return (
    <Box flexDirection="row" gap="s12">
      <Box flexDirection="column" alignItems="center">
        <Box
          width="s32"
          height="s32"
          border={{ all: { style: 'solid', width: 's1', color: 'grey400' } }}
          alignItems="center"
          justifyContent="center"
          style={{ borderRadius: '10px' }}
          padding="s2"
        >
          <Icon.Medium icon={mapEventTypeIcon(event.type)} color={'grey700'} />
        </Box>
        {showLine && <Box background="grey400" height="full" width="s1" />}
      </Box>
      <Box width="full" alignItems="flexStart" paddingBottom="s24">
        <Box gap="s4">
          <Text.Normal weight="medium" ellipsis lineClamp={2} size="200" color={'grey1000'}>
            {mapEventText(event.type)}
          </Text.Normal>
          <Text.Normal weight="normal" size="200" color="grey800">
            {dateBackendDateTimeToUI(event.date) + ' ' + dateBackendDateTimeToUITime(event.date)}
          </Text.Normal>
        </Box>
        {event.status === 'error' && (
          <Box flexDirection="row" gap="s4">
            <Text.Normal weight="normal" size="200" color="radicalRed800">
              {getEventErrorMessage(event)}
            </Text.Normal>
          </Box>
        )}
      </Box>
    </Box>
  )
}
